import { render, staticRenderFns } from "./Boundshop.vue?vue&type=template&id=81db4bf6&scoped=true"
import script from "./Boundshop.vue?vue&type=script&lang=js"
export * from "./Boundshop.vue?vue&type=script&lang=js"
import style0 from "./Boundshop.vue?vue&type=style&index=0&id=81db4bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db4bf6",
  null
  
)

export default component.exports